module.exports = __webpack_public_path__ + "img/customer-icon-active.4dbc3f03.svg";